export class Hud {
  private readonly level = this.getElement('#level-name');
  private readonly progress = this.getElement('#progress-value');
  private readonly status = this.getElement('#status-line');
  private readonly nearby = this.getElement('#nearby-prompt');
  private readonly reflection = this.getElement('#reflection-copy');
  private readonly reflectionModal = this.getElement('#reflection-modal');
  private readonly endModal = this.getElement('#end-modal');

  setLevel(name: string, progress: string): void {
    this.level.textContent = name;
    this.progress.textContent = progress;
  }

  setNearby(message: string): void {
    this.nearby.textContent = message;
  }

  setStatus(message: string): void {
    this.status.textContent = message;
  }

  showReflection(copy: string): void {
    this.reflection.textContent = copy;
    this.reflectionModal.removeAttribute('hidden');
  }

  closeReflection(): void {
    this.reflectionModal.setAttribute('hidden', '');
  }

  showEnd(): void {
    this.endModal.removeAttribute('hidden');
  }

  closeEnd(): void {
    this.endModal.setAttribute('hidden', '');
  }

  private getElement<T extends HTMLElement = HTMLElement>(selector: string): T {
    const element = document.querySelector<T>(selector);
    if (!element) throw new Error(`Missing HUD element: ${selector}`);
    return element;
  }
}
